module.exports = "/_next/static/images/sc-5c844462354dd537726fcd6c9b792521.png";